import { render, staticRenderFns } from "./manage-system-template-page.vue?vue&type=template&id=023f3527&scoped=true"
import script from "./manage-system-template-page.vue?vue&type=script&lang=js"
export * from "./manage-system-template-page.vue?vue&type=script&lang=js"
import style0 from "./manage-system-template-page.vue?vue&type=style&index=0&id=023f3527&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f3527",
  null
  
)

export default component.exports